// Mock data for Laikos Lay Schools - Editable content
export const siteConfig = {
  siteName: "Laikos Lay Schools",
  heroTitle: "LAIKOS LAY SCHOOLS",
  heroBackgroundImage: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=1920&q=80",
};

export const navigationItems = [
  { id: 1, label: "Home", href: "/", hasDropdown: false },
  { id: 7, label: "ORGANIZATIONAL STRUCTURE", href: "/organization", hasDropdown: false },
  { 
    id: 2, 
    label: "Schools", 
    href: "/schools", 
    hasDropdown: true,
    dropdownItems: [
      { id: 21, label: "School of Solid Foundation", href: "/school/solid-foundation" },
      { id: 22, label: "School of the Word", href: "/school/the-word" },
      { id: 23, label: "School of Victorious Living", href: "/school/victorious-living" },
      { id: 24, label: "School of Evangelism", href: "/school/evangelism" },
      { id: 25, label: "School of Apologetics", href: "/school/apologetics" }
    ]
  },
  { 
    id: 4, 
    label: "Écoles", 
    href: "/ecoles", 
    hasDropdown: true,
    dropdownItems: [
      { id: 41, label: "École de la Fondation Solide", href: "/ecole/fondation-solide" },
      { id: 42, label: "École de la Parole", href: "/ecole/la-parole" },
      { id: 43, label: "École de la Vie Victorieuse", href: "/ecole/vie-victorieuse" },
      { id: 44, label: "École d'Évangélisation", href: "/ecole/evangelisation" },
      { id: 45, label: "École d'Apologétique", href: "/ecole/apologetique" }
    ]
  },
  { id: 5, label: "EXAM RESULTS", href: "/exam-results", hasDropdown: false },
  { id: 6, label: "STATISTICS", href: "/statistics", hasDropdown: false },
  { id: 7, label: "ARCHIVE", href: "/archive", hasDropdown: false },
  { id: 8, label: "SETTINGS", href: "/admin/settings", hasDropdown: false },
  { id: 9, label: "SMS", href: "/admin/sms", hasDropdown: false },
  { 
    id: 10, 
    label: "MANAGEMENT", 
    href: "/admin/teachers", 
    hasDropdown: true,
    dropdownItems: [
      { id: 101, label: "Teachers & Students", href: "/admin/teachers" },
      { id: 102, label: "School Dates", href: "/admin/school-management" }
    ]
  }
];

export const languageButtons = [
  { id: 1, label: "ENGLISH SCHOOLS", href: "/schools", color: "#5f7c8a" },
  { id: 3, label: "ÉCOLES-FRANÇAIS", href: "/ecoles", color: "#5f7c8a" }
];

export const adminCards = [
  {
    id: 1,
    title: "[TEACHING MATERIALS]",
    image: "https://customer-assets.emergentagent.com/job_laikos-schools/artifacts/8ay2r3fu_IMG_1754.png",
    href: "/teaching-materials",
    description: "Access teaching resources and materials"
  },
  {
    id: 2,
    title: "[EXAM RESULTS]",
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400&q=80",
    href: "/exam-results",
    description: "View examination results dashboard"
  },
  {
    id: 3,
    title: "[OVERALL STATISTICS]",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&q=80",
    href: "/statistics",
    description: "School performance statistics"
  }
];

export const schoolsData = {
  english: [
    { id: 1, name: "School of Solid Foundation", location: "Zurich", students: 250, description: "Building strong biblical foundations" },
    { id: 2, name: "School of the Word", location: "Geneva", students: 320, description: "Deep study of scriptures" },
    { id: 3, name: "School of Victorious Living", location: "Bern", students: 180, description: "Living in victory through Christ" },
    { id: 4, name: "School of Evangelism", location: "Basel", students: 210, description: "Spreading the gospel worldwide" },
    { id: 5, name: "School of Apologetics", location: "Lausanne", students: 175, description: "Defending the faith" }
  ],
  french: [
    { id: 1, name: "École de la Fondation Solide", location: "Lausanne", students: 195 },
    { id: 2, name: "École de la Parole", location: "Neuchâtel", students: 145 }
  ]
};

export const examResultsData = [
  // English Schools
  { id: 1, school: "School of Solid Foundation", year: 2024, passRate: 94, avgScore: 78.5 },
  { id: 2, school: "School of the Word", year: 2024, passRate: 91, avgScore: 75.2 },
  { id: 3, school: "School of Victorious Living", year: 2024, passRate: 96, avgScore: 82.1 },
  { id: 4, school: "School of Evangelism", year: 2024, passRate: 93, avgScore: 79.8 },
  { id: 5, school: "School of Apologetics", year: 2024, passRate: 89, avgScore: 76.4 },
  // French Schools
  { id: 6, school: "École de la Fondation Solide", year: 2024, passRate: 92, avgScore: 77.5 },
  { id: 7, school: "École de la Parole", year: 2024, passRate: 88, avgScore: 74.8 },
  { id: 8, school: "École de la Vie Victorieuse", year: 2024, passRate: 95, avgScore: 81.2 },
  { id: 9, school: "École d'Évangélisation", year: 2024, passRate: 90, avgScore: 78.1 },
  { id: 10, school: "École d'Apologétique", year: 2024, passRate: 87, avgScore: 75.9 }
];

export const statisticsData = {
  totalStudents: 1475,
  totalSchools: 10,
  averagePassRate: 91.5,
  averageScore: 77.9,
  yearlyGrowth: 5.2
};

export const footerContent = {
  text: "Laikos Lay Schools © 2025",
  reportAbuseLink: "#"
};
